import { AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, OnInit, ViewChild, input } from '@angular/core';
import { Rekbot } from '../../../models/rekbot.model';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { RekbotsService } from '../../../services/rekbots.service';
import { RekbotLogItem } from '../../../models/rekbotLogItem.model';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CommonModule, DatePipe, NgFor, NgIf } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { finalize, map, Observable, pipe, Subject, take, takeUntil } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { getPolishPaginatorIntl } from '../../../polish-paginator-intl';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { NotificationService } from '../../../services/notification.service';
import {MatTabsModule} from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { RekbotStateService } from '../rekbot-layout-services/rekbot-state.service';
import { AuthService } from '../../../services/auth.service';
import { ROLES } from '../../../constants/roles.constants';

@Component({
  selector: 'app-rekbot',
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginatorModule,
    //MatPaginatorIntl,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    DatePipe,
    NgIf,
    MatCardModule,
    MatButtonModule,
    MatTabsModule,
    FormsModule,
    CommonModule,
    MatButtonToggleModule
],
  templateUrl: './rekbot-info.component.html',
  styleUrl: './rekbot-info.component.scss',
  providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class RekbotInfoComponent implements OnInit, AfterViewInit{

  readonly ROLES = ROLES;

  // private destroy$ = new Subject<void>();

  public editForm: FormGroup;
  public status: FormControl;

  public isChangingProdStatus:boolean = false;
  public selectedStatus: FormControl = new FormControl(-1);
  public userPermission:number = ROLES.user;
  // public selectedStatus: number = -1;

  public productionStatus = [
    { id: 0, name:"Magazyn" },
    { id: 1, name:"Montaż" },
    { id: 2, name:"Klient" }
]



  initForm(rekbot: Rekbot) {
    this.editForm = new FormGroup({
      id: new FormControl(rekbot.id, [Validators.required]),
      serial_no: new FormControl(rekbot.serial_no, [Validators.required]),
      ipv4: new FormControl(rekbot.ipv4, [Validators.required]),
      port: new FormControl(rekbot.port, [Validators.required]),
      //ipv6: new FormControl(rekbot.ipv6, [Validators.required]),
      status: new FormControl(rekbot.status, [Validators.required]),
      last_synced_at: new FormControl(rekbot.last_synced_at, [Validators.required]),
      restart_message: new FormControl(rekbot.restart_message, [Validators.required]),
      restart_application: new FormControl(rekbot.restart_application, [Validators.required]),
      restart_api: new FormControl(rekbot.restart_api, [Validators.required]),
      restart_plc: new FormControl(rekbot.restart_plc, [Validators.required]),
      restart_pc: new FormControl(rekbot.restart_pc, [Validators.required])
    })
  }

  public dataSource = new MatTableDataSource<any>(this.rekbotLog);

  public totalData: number = 0;
  public currentPage: Observable<string>;

  public pageSizes = [10, 20, 50];

  public isLoading = false;

  public displayedColumns: string[] = [
    'status',
    'message',
    'rekbot_created_at',
    'created_at',
  ];

  public params = {
    page: 1,
    size: 10,
    sort: 'id,DESC',
    sorts: {
      prop: 'id',
      dir: 'DESC'
    },
    search: ''
  };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;


  elementId: number;
  rekbot: Rekbot = Rekbot.empty()

  rekbotLog?: RekbotLogItem[]

  //@ViewChild('')

  constructor(
    private rekbotStateService: RekbotStateService,
    private rekbotsService: RekbotsService,
    private modalService: NgbModal,
    public router: Router,
    private notificationService: NotificationService,
    private authService: AuthService,

  ) {
    //this.rekbot = null;
    this.elementId = 0
    this.rekbot = Rekbot.empty()

    this.editForm = new FormGroup({
      id: new FormControl("", [Validators.required]),
      serial_no: new FormControl("", [Validators.required]),
      ipv4: new FormControl("", [Validators.required]),
      port: new FormControl("", [Validators.required]),
      ipv6: new FormControl("", [Validators.required]),
      status: new FormControl("", [Validators.required]),
      last_synced_at: new FormControl("", [Validators.required]),
      restart_message: new FormControl("", [Validators.required]),
      restart_application: new FormControl("", [Validators.required]),
      restart_api: new FormControl("", [Validators.required]),
      restart_plc: new FormControl("", [Validators.required]),
      restart_pc: new FormControl("", [Validators.required])
    })

    this.status = new FormControl('', [Validators.required]);


    this.currentPage = new Observable(
      function (observer) {
        try {
          console.log("observer", observer)
          observer.next()

        } catch (error) {
          console.error("error", error)
          observer.error(error)

        }
      }
    );
  }

  pageChanged(event: PageEvent) {
    console.log("pageChanged", event)
    this.params.page = event.pageIndex + 1
    this.params.size = event.pageSize

    this.fetchLog()
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    /*this.paginator.page
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoading = true;

        return this.getTableData$(
          this.paginator.pageIndex + 1,
          this.paginator.pageSize
        ).pipe(catchError(() => observableOf(null)));
      }),
      map((empData) => {
        if (empData == null) return [];
        this.totalData = empData.total;
        this.isLoading = false;
        return empData.data;
      })
    )
    .subscribe((empData) => {
      this.EmpData = empData;
      this.dataSource = new MatTableDataSource(this.EmpData);
    });*/

  }

  ngOnInit(): void {
    this.userPermission = this.authService.getUser()!.role!.role_id;
    this.rekbotStateService.state$
    // .pipe(takeUntil(this.destroy$),finalize(() => console.log("rekbotStateService unsub")))
    .pipe(take(1))
    .subscribe(state => this.rekbot = state.rekbot)

    // this.route.data
    // // .pipe(take(1))
    // .subscribe(data => {
    //   this.rekbot = data['rekbot_data'].rekbot_res.rekbot as Rekbot;
    // });
    
    this.selectedStatus.setValue(this.rekbot.production_status)
    this.rekbot.namedStatus = (this.rekbot.status === 0) ? "ERROR" : "OK"
    this.fetchLog()

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.productionStatus = this.productionStatus.filter(status => status.id !== this.rekbot.production_status);
    // this.elementId = this.route.snapshot.params['rekbotId'];

    // if (this.elementId > 0) {
    //   this.fetchRekbot(this.elementId)
    // }

  }

  doFilter(event: Event) {
    //let value = filterValue.target.value
    const filterValue = (event.target as HTMLInputElement).value;

    //console.log("do filter arg", filterValue)
    //this.dataSource.filter = filterValue.trim().toLowerCase()

    const filterText = filterValue.trim().toLowerCase()

    if (filterText.length > 2) {

      this.params.search = filterText

      this.fetchLog()
    } else if (this.params.search.length > 0 && filterText.length == 0) {

      this.params.search = filterText
      this.fetchLog()
    }
  }

  fetchRekbot(id: number): void {
    this.rekbotsService.fetchRekbot(id)
      .subscribe({
        next: (response: any) => {

          // console.log("fetchRekbot", response)

          this.rekbot = response.rekbot
          this.selectedStatus.setValue(this.rekbot.production_status)
          this.rekbot.namedStatus = (this.rekbot.status === 0) ? "ERROR" : "OK"
          this.fetchLog()

          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          this.productionStatus = this.productionStatus.filter(status => status.id !== this.rekbot.production_status);
          // console.log(this.productionStatus);
          
        },
        error: error => {
          console.log("fetchrekbot error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });

  }


  fetchLog(): void {
    this.isLoading = true
    this.rekbotsService.fetchRekbotLog(this.rekbot, this.params)
      .subscribe({
        next: (response: any) => {

          console.log("fetchLog", response)

          this.rekbotLog = response.log.data
          this.dataSource = new MatTableDataSource<any>(this.rekbotLog);
          this.totalData = response.log.total

          this.isLoading = false

          //this.dataSource.paginator = this.paginator;
          //this.dataSource.sort = this.sort;
        },
        error: error => {
          console.log("fetchrekbot error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
          this.isLoading = false
        }
      });

  }

  editRekbot() {

    console.log("edit", this.rekbot)
    if (this.rekbot.id == 0) {
      alert("Nie pobrano jeszcze danych rekbota")
      return;
    }


  }

  fetchLogFromRekbot(): void {
    this.isLoading = true
    this.rekbotsService.fetchLogFromRekbot(this.rekbot)
      .subscribe({
        next: (response: any) => {
          console.log("fetchLogFromRekbot", response)
          this.fetchRekbot(this.rekbot.id)
        },
        error: (error) => {
          console.log("fetchrekbot error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });

  }

  restartApplication(rekbot: Rekbot) {
    if (confirm("Do you really want to restart application" + rekbot.serial_no)) {
      this.rekbotsService.restartApplication(rekbot)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.fetchRekbot(this.rekbot.id)
          },
          error: error => {
            console.log("error subscribe restartApplication Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }
        });
    }
  }

  restartApi(rekbot: Rekbot) {
    if (confirm("Do you really want to restart api " + rekbot.serial_no)) {
      this.rekbotsService.restartApi(rekbot)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.fetchRekbot(this.rekbot.id)
          },
          error: error => {
            console.log("error subscribe restartApi Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }

        });
    }
  }

  restartPlc(rekbot: Rekbot) {
    if (confirm("Do you really want to restart plc " + rekbot.serial_no)) {
      this.rekbotsService.restartPlc(rekbot)
        .subscribe(
          (response: any) => {
            console.log(response);
            this.fetchRekbot(this.rekbot.id)
          },
          error => {
            console.log("error subscribe restartPlc Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }
        );
    }
  }

  restartPc(rekbot: Rekbot) {
    if (confirm("Do you really want to restart pc " + rekbot.serial_no)) {
      this.rekbotsService.restartPc(rekbot)
        .subscribe(
          (response: any) => {
            console.log(response);
            this.fetchRekbot(this.rekbot.id)
          },
          error => {
            console.log("error subscribe restartPc Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }
        );
    }
  }

  onSubmitRekbot() {

    const rekbot = new Rekbot(
      this.editForm.value.id,
      this.editForm.value.serial_no,
      this.editForm.value.ipv4,
      this.editForm.value.port,
      this.editForm.value.gps_device_id,
      //this.editForm.value.ipv6,
      this.editForm.value.status,
      0,
      //this.editForm.value.last_synced_at,
      //this.editForm.value.restart_message,
      //this.editForm.value.restart_application,
      //this.editForm.value.restart_api,
      //this.editForm.value.restart_plc,
      //this.editForm.value.restart_pc,
      0
    )

    console.log("onSubmitRekbot", rekbot)

    if (rekbot.id > 0) {
      this.rekbotsService.updateRekbot(rekbot)
        .subscribe({
          next: (response: any) => {
            console.log("subscribe updateRekbot", response);
            this.fetchRekbot(this.elementId)
          },
          error: (error) => {
            alert("Wrong data: " + error.error.message);
          }
        });
    }
  }

  public openModal(modal: any, newRekbot: boolean) {

    //this.rekbot =  rekbot
    console.log("openModal", this.rekbot)
    //this.selectedType = rekbot.type;
    //console.log(this.myBottle);

    if (this.rekbot.id) {
      this.initForm(this.rekbot)
    }

    this.modalService.open(modal);
  }

  fetchSmtpFromRekbot() {
    this.isLoading = true
    this.rekbotsService.fetchRekbotSmtp(this.rekbot.id)
      .subscribe({
        next: (response: any) => {
          console.log("fetchLogFromRekbot", response)
          //this.fetchRekbot(this.rekbot.id)
        },
        error: (error) => {
          console.log("fetchrekbot error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });


  }

  decodeLocationData() {
    if (this.rekbot !== undefined) {
      this.rekbotsService.decodeLocationData(this.rekbot?.id)
        .subscribe({
          next: (response: any) => {
            console.log("decodeLocationData", response)

            if (response.error !== undefined) {
              this.notificationService.pushNotification(
                response.error, 'error', 5000);
            } else {
              this.notificationService.pushNotification(
                `Lokalizacja zdekodowana`, 'info', 5000);
            }
          },
          error: (error) => {
            console.log("decodeLocationData error", error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        });
    }

  }

  onChangeProdStatus() {
    if(this.isChangingProdStatus ) {
      if(this.selectedStatus.value === -1){
        this.selectedStatus.setValue(this.rekbot.production_status);
      } else {
        this.rekbotsService.changeProductionStatus([this.rekbot.id], this.selectedStatus.value).subscribe({
          next: res => {
            console.log(res);
            this.fetchRekbot(this.elementId);
          },
          error: err => {
            console.error(err)
          }
        })
      }
      
    }

    this.isChangingProdStatus = !this.isChangingProdStatus
  }
}
